import clsx from 'clsx';
import { memo } from 'react';
import { Accessory } from 'src/common/Accessory/Accessory';
import { ValveAccessoriesWithType } from 'src/generated/operations';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { Switch } from 'src/modules/common/components/Switch/Switch';
import { MESSAGES } from 'src/modules/common/constants';
import { GetQty } from 'src/modules/common/utils/parseRecommended';
import { LocationState } from 'src/modules/LocationState';

type Props = {
    locationState: LocationState;
    pipeConnectors: ValveAccessoriesWithType[];
    onPipeConnectorsChange: (value: boolean) => void;
    getQty: GetQty;
}

export const ValveAccessoriesPipeConnectors = memo(({
    locationState,
    pipeConnectors,
    onPipeConnectorsChange,
    getQty,
}: Props) => (
    <div className="vss-valve-accessories-pipe-connectors">
        <p className="vss-valve-accessories-pipe-connectors__title">
            <I18n messageId={MESSAGES.PipeConnectors}/>
        </p>

        <div className={clsx({
            'vss-valve-accessories-pipe-connectors__content': true,
            'vss-valve-accessories-pipe-connectors__content--single': pipeConnectors.length === 1,
        })}
        >
            <Switch
                active={locationState.pipeConnectors}
                onChange={(event) => onPipeConnectorsChange(event.target.checked)}
                valueActive={
                    <I18n messageId={MESSAGES.pipeConnectorLabel}/>
                }
                valueInactive={<I18n messageId={MESSAGES.pipeConnectorLabel}/>}
                size="sm"
            />

            <div className={clsx({
                'vss-valve-accessories-pipe-connectors__devices': true,
                'vss-valve-accessories-pipe-connectors__devices--single': pipeConnectors.length === 1,
            })}
            >
                {pipeConnectors.map(
                    ({ item }) => (
                        <Accessory
                            qty={`${getQty(item.Label)}x`}
                            accessory={item}
                            key={`${item.Label}-${item.ID}`}
                            theme="gray"
                            disabled={!locationState.pipeConnectors}
                        />
                    ),
                )}
            </div>
        </div>
    </div>
));
